import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };

  const tableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "图书名称",
      prop: "bookName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "图书分类",
      prop: "categoryName",
      minWidth: "100"
    },
    {
      label: "展示终端",
      prop: "displayTypeName",
      minWidth: "140"
    },
    {
      label: "总学习人数",
      prop: "learnTotalCount",
      minWidth: "100"
    },
    {
      label: "已完成学习人数",
      prop: "learnCompleteCount",
      minWidth: "100",
      showOverflowTooltip: true,
    },
    {
      label: "正在学习人数",
      prop: "studyCount",
      minWidth: "100",
      showOverflowTooltip: true,
    },
    {
      label: "点击量",
      prop: "collectCount",
      minWidth: "100",
      showOverflowTooltip: true
    },
    // {
    //   label: "收藏人数",
    //   prop: "collectCount",
    //   minWidth: "100",
    //   showOverflowTooltip: true
    // },
  ];
  if (args.props.userType == -1 && args.props.deptLevelCode == "001") {
    tableConfig.splice(2, 0, {
      label: "所属分院",
      prop: "academyName",
      width: "120",
      showOverflowTooltip: true
    });
  }
  return (
    <List
      {...args}
      talbeCols={tableConfig}
      onSelectionChange={RCSelectionChange}
    />
  );
};

export default Table;
